import { motion, AnimatePresence } from 'framer-motion';

interface ExpandableTextareaProps {
  textareaContent: string;
  setTextareaContent: (value: string) => void;
  isVisible: boolean;
  questionTitle: string;
  textAreaPlaceHolder: string;
}

const ExpandableTextarea: React.FC<ExpandableTextareaProps> = ({
  textareaContent,
  setTextareaContent,
  isVisible,
  questionTitle,
  textAreaPlaceHolder,
}) => {
  const [title, subtitle] = questionTitle.split(/[?.]/);
  const formattedTitle = subtitle ? `${title}${questionTitle[title.length]}` : title;

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className={`overflow-hidden ${isVisible ? 'block' : 'hidden'}`}
          initial={{ maxHeight: 0 }}
          animate={{ maxHeight: 500 }}
          exit={{ opacity: 0, maxHeight: 0 }}
          transition={{ duration: 0.4, ease: 'easeInOut' }}
        >
          <div className="rounded-[8px] tablet:rounded-[12px] bg-off-gray border border-amberblack">
            <div className="p-16 tablet:p-24 tablet:pb-20 bg-paper text-body text-amberblack tablet:text-ashgray-less-soft rounded-t-[8px] tablet:rounded-t-[12px]">
              <p>{formattedTitle}</p>
              {subtitle && <p className="text-[12px] leading-[17px]">{subtitle}</p>}
            </div>
            <textarea
              value={textareaContent}
              onChange={(e) => setTextareaContent(e.target.value)}
              placeholder={textAreaPlaceHolder}
              className="w-full h-[142px] tablet:h-[192px] p-16 pt-12 tablet:p-24 tablet:pt-20 text-body text-amberblack placeholder:text-silver focus:outline-none"
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ExpandableTextarea;
